import { getStore } from '../store/Store';
import { getSelectedTableView, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
import { isDeepLink } from 'owa-url';

export default function getPrimaryTabId(): string {
    const tableView = getSelectedTableView();
    if (tableView) {
        const isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
        const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
        if (selectedRowKeys.length == 1 && !isInVirtualSelectAllMode) {
            return MailRowDataPropertyGetter.getRowIdString(selectedRowKeys[0], tableView);
        }
    }

    if (isDeepLink()) {
        return getStore().deeplinkId?.id;
    }

    trace.warn('Unable to get the primary tab id.');
    return null;
}
